import { Box, Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
// Disabling rule due to this issue https://stackoverflow.com/questions/69202975/module-not-found-cant-resolve-swiper-react
/* eslint-disable import/no-unresolved */
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import SwiperCarousel from '../shared/SwiperCarousel';
import ContentCarousel from '../eir-content-carousel/ContentCarousel';
import styles from './styles';

// import EirInformation from '../eir-information/EirInformation';

const MobileContentCarousel = contentCarousel => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const style = styles(theme);
  return (
    <Box>
      {/* <Box sx={{ ...{ mb: { xs: 15, md: 9 } }, ...{ mt: { md: 2.5 } } }}> */}
      {/* <Box sx={{ p: 2, m: '0 15px', color: theme.palette.primary.main }}>
        <EirInformation
          title='Lorem ipsum dolor sit amet elits sed'
          description=''
          sx={{ m: '0 auto' }}
        />
      </Box> */}

      {sm ? (
        <SwiperCarousel
          settings={{
            className: 'content-carousel',
            pagination: { enable: true, clickable: true },
            modules: [Pagination],
            initialSlide: 0,
            updateOnWindowResize: true,
            slidesPerView: 'auto',
            breakpoints: {
              320: {
                slidesPerView: 1,
              },
              600: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            },
          }}
          style={style.imageSlider.swiper}
        >
          {contentCarousel?.contentCarousel.map((content, i) => (
            <SwiperSlide key={i}>
              <ContentCarousel {...content} />
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      ) : (
        <Grid
          container
          maxWidth='lg'
          spacing={{ xs: 2, sm: 2, md: 2 }}
          sx={styles(theme).mobileCarousel}
        >
          {contentCarousel?.contentCarousel.map((content, i) => (
            <ContentCarousel {...content} key={i} />
          ))}
        </Grid>
      )}
    </Box>
  );
};
export default React.memo(MobileContentCarousel);
